/* Template: Make Elements Equal Heights
 ========================================================================== */

template.equalContainers = debounce( function() {
    'use strict';

    var mq = template.media_query();

    if ( ['md','lg','xl'].indexOf(mq) !== -1) {
        $('.homepage-cta_content').matchHeight({ byRow: false });
        $('.homepage-articles_article__title').matchHeight({ byRow: false });
        $('.homepage-articles_article__excerpt').matchHeight({ byRow: false });
        $('.donation-type__description').matchHeight({ byRow: true });
    }else {
        $('.homepage-cta_content').matchHeight({ remove: true });
        $('.homepage-articles_article__title').matchHeight({ remove: true });
        $('.homepage-articles_article__excerpt').matchHeight({ remove: true });
        $('.donation-type__description').matchHeight({ remove: true });
    }

});

window.addEventListener('resize', template.equalContainers);
